import { bootstrapApplication } from '@angular/platform-browser';
import { prepareApp } from '@core/utils';
import { App } from './app/app';
import { appConfig } from './app/app.config';

prepareApp().then(() => {
  bootstrapApplication(App, appConfig).catch((err) => console.error(err));
});
